module.exports = __webpack_public_path__ + "img/maison22.ad6cc61f.jpg";